import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var Stepper = React.forwardRef(function Stepper(_a, ref) {
    var _b;
    var type = _a.type, steps = _a.steps, current = _a.current, readonly = _a.readonly, nowrap = _a.nowrap, className = _a.className, props = __rest(_a, ["type", "steps", "current", "readonly", "nowrap", "className"]);
    var classPrefix = useConfig().classPrefix;
    var stepperClassName = classNames((_b = {},
        _b[classPrefix + "-step"] = true,
        _b[classPrefix + "-step--vertical-new"] = type === "vertical",
        _b[classPrefix + "-step--alternative"] = type === "process",
        _b[classPrefix + "-step--vertical"] = type === "process-vertical",
        _b[classPrefix + "-step--dot"] = type === "process-vertical-dot",
        _b[classPrefix + "-step--readonly"] = readonly,
        _b[classPrefix + "-step--wrap-normal"] = nowrap,
        _b[className] = className,
        _b));
    return (React.createElement("div", __assign({ ref: ref, className: stepperClassName }, props), steps.map(function (step, index, steps) { return (React.createElement("div", { key: step.id, className: classNames(classPrefix + "-step__item", step.className, {
            "is-current": !readonly && step.id === current,
        }), style: step.style },
        React.createElement("div", { className: classPrefix + "-step__num" }, index + 1),
        React.createElement("div", { className: classPrefix + "-step__content" },
            React.createElement("div", { className: classPrefix + "-step__title" }, step.label),
            step.detail && (React.createElement("div", { className: classPrefix + "-step__description" }, step.detail))),
        step.tip && (React.createElement("div", { className: classPrefix + "-step__tips" }, step.tip)),
        index < steps.length - 1 && (React.createElement("div", { className: classPrefix + "-step__arrow" })))); })));
});
Stepper.displayName = "Stepper";
//# sourceMappingURL=Stepper.js.map